var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3c1.654 0 3 1.346 3 3v12c0 1.654-1.346 3-3 3H3c-1.654 0-3-1.346-3-3V6c0-1.654 1.346-3 3-3zm1 3.203l-9.372 7.575a.996.996 0 01-1.256 0L2 6.203V18c0 .551.449 1 1 1h18c.551 0 1-.449 1-1V6.203zM20.307 5H3.693L12 11.714 20.307 5z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconMessage;